export const DEFAULT_SUGGESTIONS = ['chatbot.prompt.0', 'chatbot.prompt.1'] as const;
